import script from "./DismissedReceiptsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DismissedReceiptsView.vue?vue&type=script&setup=true&lang=js"

import "./DismissedReceiptsView.vue?vue&type=style&index=0&id=64c3ca32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c3ca32"]])

export default __exports__